/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { SkeletonLine } from '@one-thd/sui-atomic-components';

const Breadcrumbs = ({ isSkeleton }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  if (isSkeleton) {
    return (
      <div
        className="sui-grid sui-grid-cols-2 sm:sui-grid-cols-4 sui-gap-4 sui-w-[30rem]"
        data-component="BreadcrumbsPlaceholder"
      >
        {[...Array(isMobile ? 2 : 4)].map((i) => (
          <SkeletonLine key={i} variant="single" />
        ))}
      </div>
    );
  }

  const breadcrumbs = useSelector((state) => state.config.breadcrumbs);

  return (
    <div>
      <ul className="list list--type-plain breadcrumb__header">
        {breadcrumbs && breadcrumbs.map((b) => (
          <li key={b.id} className="breadcrumb__item ">
            <a
              className="list__link breadcrumb__link"
              href={b.url}
            >
              {b.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

Breadcrumbs.propTypes = {
  isSkeleton: PropTypes.bool,
};

Breadcrumbs.defaultProps = {
  isSkeleton: false,
};

export default Breadcrumbs;
